var _title, _circle, _path, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMarkerMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "eebc9664-382d-4fda-b8cc-66ca106f123b",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icoontjes_data")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 512,
  cy: 357.6,
  r: 36.4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M512,535.4h0a24.64,24.64,0,0,1-18.3-8.2c-12.7-14.4-37.3-43.1-58.7-74.4-27.7-40.5-41.2-71.6-41.2-95.2a118.1,118.1,0,0,1,236.2,0c0,23.5-13.5,54.7-41.2,95.2-21.4,31.3-46,60.1-58.7,74.4A23.9,23.9,0,0,1,512,535.4Zm0-270a92.35,92.35,0,0,0-92.2,92.2c0,34.5,47.4,100.4,92.2,151.1,44.8-50.7,92.2-116.6,92.2-151.1A92.29,92.29,0,0,0,512,265.4Z"
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "610.6 677.8 372.5 677.8 406.5 610.5 577.2 610.5 610.6 677.8"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "662.5 780.6 253.1 780.6 337.6 610 371.9 610 323 713.3 629 713.3 662.5 780.6"
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  points: "713.9 677.8 646.1 677.8 612.2 610.5 680.5 610.5 713.9 677.8"
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  points: "766 780.9 698.2 780.9 664.2 713.6 732.5 713.6 766 780.9"
})));
export default SvgIconMarkerMap;